module.exports = __webpack_public_path__ + "79864b2c59d7acc22fb0461090a9037d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/2_C#2.mp3
// module id = 77
// module chunks = 0